// The data provider rejects with an Error whose message is the stringified back-end payload, so
// that callers can read its errorCode. That makes it unfit to display as-is: these helpers turn it
// back into something readable, and tolerate the messages that are not JSON (network, plain status).

/**
 * Structured back-end error payload carried by a rejected data provider promise.
 * @param {Error} err the rejected error
 * @returns {Object} the payload, or an empty object when the message is not a JSON payload
 */
export const parseApiError = err => {
  try {
    const parsed = JSON.parse(err && err.message);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (e) {
    return {};
  }
};

/**
 * A single readable line for a rejected data provider promise. Falls back to the raw message, which
 * for a non-JSON payload is a translation key such as "error.500" or "error.network".
 * @param {Error} err the rejected error
 * @returns {string} the message to notify
 */
export const getApiErrorMessage = err => parseApiError(err).message || (err && err.message) || '';
